<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Divyang Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Divyang Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Designation & Organization</th>
                <th>Designation in the Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>Dr. H. R. Kulkarni</td>
                <td>Director</td>
                <td>Chairman</td>
              </tr>
              <tr>
                <td>02</td>
                <td>Dr. Praveen Jangade</td>
                <td>Dy. Director</td>
                <td>Vice Chairman</td>
              </tr>
              <tr>
                <td>03</td>
                <td>Mr. Sujitkumar Karande</td>
                <td>Registrar</td>
                <td>Expert Advisor</td>
              </tr>
              <tr>
                <td>04</td>
                <td>Mrs. Sheela Satav</td>
                <td>Dean Academics & Asst. Prof.</td>
                <td>Expert Advisor</td>
              </tr>
              <tr>
                <td>05</td>
                <td>Mr. Vishal Waghole</td>
                <td>Dean Student Development</td>
                <td>Member Secretary</td>
              </tr>
              <tr>
                <td>06</td>
                <td>Mrs. Deepika Khandelwal</td>
                <td>Dean IQAC</td>
                <td>Teacher Representative Female</td>
              </tr>
              <tr>
                <td>07</td>
                <td>Mr. Abhay Kand</td>
                <td>HoD, Dept. of Commerce</td>
                <td>Teacher Representative Male</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
